var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-main',{ref:"main",attrs:{"tableData":_vm.tableData,"disabled":_vm.disabled},on:{"delRow":_vm.delRow}},[_c('page-header',{ref:"header",attrs:{"slot":"header"},slot:"header"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }